module.exports = __webpack_public_path__ + "poster13.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster13.png
// module id = 1143
// module chunks = 10